import { roomSlice } from 'redux/slices/room/roomSlice'

export * from 'redux/slices/room/roomActions'
export * from 'redux/slices/room/roomSelectors'

export const { setSearchParams, setReservationData, resetRoomState } =
  roomSlice.actions

export default roomSlice.reducer
